/* ==========================================================================
   Techno Cult — Returns & EU Withdrawal experience — shared behaviour
   Scoped entirely to elements carrying tc-* classes/attributes so it cannot
   collide with theme or app JS. No localStorage. sessionStorage is used only
   as an ephemeral relay to redisplay a customer's own submitted answers on
   the same-page reload that follows a native Shopify contact-form post; nothing
   is sent anywhere except Shopify's own /contact endpoint.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__tcReturnsLoaded) return; // guard: sections may each include this file
  window.__tcReturnsLoaded = true;

  function tcInit() {
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- smooth scroll for [data-tc-scroll-to] ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-tc-scroll-to]");
    if (!btn) return;
    var targetSel = btn.getAttribute("data-tc-scroll-to");
    var target = targetSel && document.querySelector(targetSel);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    var focusable = target.querySelector("h1,h2,h3,[tabindex]");
    if (focusable) { focusable.setAttribute("tabindex", "-1"); focusable.focus({ preventScroll: true }); }
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll(".tc-faq").forEach(function (faq) {
    faq.addEventListener("click", function (e) {
      var q = e.target.closest(".tc-faq-q");
      if (!q) return;
      var item = q.closest(".tc-faq-item");
      var isOpen = item.getAttribute("data-open") === "true";
      if (faq.getAttribute("data-tc-single-open") === "true") {
        faq.querySelectorAll('.tc-faq-item[data-open="true"]').forEach(function (open) {
          if (open !== item) { open.setAttribute("data-open", "false"); open.querySelector(".tc-faq-q").setAttribute("aria-expanded", "false"); }
        });
      }
      item.setAttribute("data-open", isOpen ? "false" : "true");
      q.setAttribute("aria-expanded", isOpen ? "false" : "true");
    });
  });

  /* ---------- scroll-based center highlight ---------- */
  if ("IntersectionObserver" in window) {
    document.querySelectorAll("[data-tc-highlight-root]").forEach(function (root) {
      var onDesktop = root.getAttribute("data-hl-desktop") !== "false";
      var onMobile = root.getAttribute("data-hl-mobile") !== "false";
      var isMobile = window.matchMedia("(max-width: 749px)").matches;
      if ((isMobile && !onMobile) || (!isMobile && !onDesktop)) return;

      var trigger = parseFloat(root.getAttribute("data-hl-trigger") || "0.5");
      var margin = Math.round((1 - trigger) * 100);
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle("is-active", entry.isIntersecting);
          });
        },
        { root: null, rootMargin: "-" + margin + "% 0px -" + margin + "% 0px", threshold: 0 }
      );
      root.querySelectorAll(".tc-hl").forEach(function (card) {
        if (card.getAttribute("data-hl-disabled") === "true") return;
        io.observe(card);
      });
    });
  }

  /* ---------- Withdrawal form ---------- */
  var form = document.getElementById("tc-withdrawal-form");
  if (form && form.tagName !== "FORM") {
    // The section wrapper shares the same id as the <form> (used as a scroll
    // target), so getElementById returns the first match in document order —
    // the <section>, not the <form>. Find the actual <form> inside it instead.
    form = form.querySelector("form#tc-withdrawal-form") || form.querySelector("form.tc-form");
  }
  if (form) {
    var SESSION_KEY = "tc_withdrawal_last_submission";

    var rowsWrap = form.querySelector("[data-tc-product-rows]");
    var addRowBtn = form.querySelector("[data-tc-add-row]");
    var rowTemplate = form.querySelector("template[data-tc-row-template]");

    function reindexRows() {
      if (!rowsWrap) return;
      rowsWrap.querySelectorAll(".tc-product-row").forEach(function (row, i) {
        row.querySelectorAll("[data-field]").forEach(function (f) {
          f.setAttribute("aria-label", f.getAttribute("data-field") + " — item " + (i + 1));
        });
      });
    }

    if (addRowBtn && rowTemplate && rowsWrap) {
      addRowBtn.addEventListener("click", function () {
        var clone = rowTemplate.content.cloneNode(true);
        rowsWrap.appendChild(clone);
        reindexRows();
      });
      rowsWrap.addEventListener("click", function (e) {
        var rm = e.target.closest(".tc-product-row__remove");
        if (!rm) return;
        var rows = rowsWrap.querySelectorAll(".tc-product-row");
        if (rows.length <= 1) return; // keep at least one row
        rm.closest(".tc-product-row").remove();
        reindexRows();
      });
    }

    function fieldValue(name) {
      var el = form.querySelector('[name="tc_' + name + '"]');
      return el ? el.value.trim() : "";
    }

    function setError(name, message) {
      var el = form.querySelector('[name="tc_' + name + '"]');
      if (!el) return;
      var wrap = el.closest(".tc-field");
      var errEl = wrap && wrap.querySelector(".tc-field-error");
      if (wrap) wrap.classList.toggle("has-error", !!message);
      if (errEl) errEl.textContent = message || "";
    }

    var REQUIRED = ["first_name", "last_name", "email", "address", "postal_code", "city", "country", "order_number", "order_date", "received_date"];

    function validate() {
      var ok = true;
      var firstInvalid = null;
      REQUIRED.forEach(function (name) {
        var val = fieldValue(name);
        if (!val) {
          ok = false;
          setError(name, "Please fill in this field.");
          if (!firstInvalid) firstInvalid = form.querySelector('[name="tc_' + name + '"]');
        } else {
          setError(name, "");
        }
      });
      var emailVal = fieldValue("email");
      if (emailVal && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        ok = false;
        setError("email", "Please enter a valid email address.");
        if (!firstInvalid) firstInvalid = form.querySelector('[name="tc_email"]');
      }
      if (!ok && firstInvalid) firstInvalid.focus();
      return ok;
    }

    function collectProducts() {
      if (!rowsWrap) return [];
      var rows = [];
      rowsWrap.querySelectorAll(".tc-product-row").forEach(function (row) {
        var title = row.querySelector('[data-field="title"]');
        var variant = row.querySelector('[data-field="variant"]');
        var qty = row.querySelector('[data-field="qty"]');
        var sku = row.querySelector('[data-field="sku"]');
        var t = title ? title.value.trim() : "";
        if (!t) return;
        rows.push({
          title: t,
          variant: variant ? variant.value.trim() : "",
          qty: qty ? qty.value.trim() || "1" : "1",
          sku: sku ? sku.value.trim() : ""
        });
      });
      return rows;
    }

    function referenceNumber() {
      var d = new Date();
      var pad = function (n) { return String(n).padStart(2, "0"); };
      return "TC-WD-" + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + "-" + Math.random().toString(36).slice(2, 7).toUpperCase();
    }

    function buildSummary(ref) {
      var products = collectProducts();
      var lines = [];
      lines.push("WITHDRAWAL NOTICE — " + ref);
      lines.push("Submitted: " + new Date().toLocaleString());
      lines.push("");
      lines.push("Name: " + fieldValue("first_name") + " " + fieldValue("last_name"));
      lines.push("Email: " + fieldValue("email"));
      lines.push("Address: " + fieldValue("address") + ", " + fieldValue("postal_code") + " " + fieldValue("city") + ", " + fieldValue("country"));
      lines.push("");
      lines.push("Order number: " + fieldValue("order_number"));
      lines.push("Order date: " + fieldValue("order_date"));
      lines.push("Goods received: " + fieldValue("received_date"));
      lines.push("");
      lines.push("Products covered by this withdrawal:");
      if (products.length) {
        products.forEach(function (p) {
          lines.push("  - " + p.title + (p.variant ? " (" + p.variant + ")" : "") + " x" + p.qty + (p.sku ? " [SKU " + p.sku + "]" : ""));
        });
      } else {
        lines.push("  (none listed)");
      }
      var reason = fieldValue("reason");
      if (reason) { lines.push(""); lines.push("Reason given (optional, informational only): " + reason); }
      var msg = fieldValue("message");
      if (msg) { lines.push(""); lines.push("Additional message: " + msg); }
      lines.push("");
      lines.push('Statement: "' + (form.getAttribute("data-statement-text") || "I hereby give notice that I withdraw from the contract for the purchase of the goods identified in this form.") + '"');
      var signee = fieldValue("signee");
      if (signee) lines.push("Submitted by: " + signee);
      return lines.join("\n");
    }

    var bodyField = form.querySelector('[name="contact[body]"]');
    var nameField = form.querySelector('[name="contact[name]"]');
    var emailField = form.querySelector('[name="contact[email]"]');
    var refField = form.querySelector('[name="tc_reference"]');

    form.addEventListener("submit", function (e) {
      if (!validate()) {
        e.preventDefault();
        return;
      }
      var ref = referenceNumber();
      var summary = buildSummary(ref);
      if (bodyField) bodyField.value = summary;
      if (nameField) nameField.value = (fieldValue("first_name") + " " + fieldValue("last_name")).trim();
      if (emailField) emailField.value = fieldValue("email");
      if (refField) refField.value = ref;

      try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify({ ref: ref, summary: summary, ts: Date.now() }));
      } catch (err) { /* storage unavailable — non-fatal */ }
      /* allow native submit to proceed to Shopify's contact form handler */
    });

    /* ---------- success state (after native reload, form.posted_successfully? true) ---------- */
    var successPanel = document.getElementById("tc-withdrawal-success");
    if (successPanel && successPanel.getAttribute("data-posted") === "true") {
      var refOut = successPanel.querySelector("[data-tc-ref]");
      var downloadBtn = successPanel.querySelector("[data-tc-download]");
      var printBtn = successPanel.querySelector("[data-tc-print]");
      var stash = null;
      try { stash = JSON.parse(sessionStorage.getItem(SESSION_KEY) || "null"); } catch (err) { stash = null; }

      if (stash && stash.ref) {
        if (refOut) refOut.textContent = stash.ref;
        if (downloadBtn) {
          downloadBtn.addEventListener("click", function () {
            var blob = new Blob([stash.summary], { type: "text/plain" });
            var url = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url; a.download = stash.ref + ".txt";
            document.body.appendChild(a); a.click(); a.remove();
            URL.revokeObjectURL(url);
          });
        }
      } else if (refOut) {
        refOut.textContent = "on file — check your email confirmation";
      }
      if (printBtn) printBtn.addEventListener("click", function () { window.print(); });

      try { sessionStorage.removeItem(SESSION_KEY); } catch (err) { /* noop */ }
      form.style.display = "none";
      successPanel.classList.add("is-visible");
      successPanel.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    }
  }
  }

  /* The script tag is included at the top of every section (before that
     section's own markup, and long before later sections on the page), and
     Shopify's `script_tag` filter does not add `defer`. That means this file
     can start running before most of the page's HTML — including the FAQ
     accordion, the scroll-highlight cards and the withdrawal form itself —
     has been parsed into the DOM. Deferring all the DOM-dependent setup
     until the document is actually ready fixes that, regardless of where in
     the page this particular copy of the script happened to load first. */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tcInit);
  } else {
    tcInit();
  }
})();
